<template>
  <div class="router-transitions">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'AppLayoutBlank',
};
</script>
